/* eslint-disable no-plusplus */
import querystring from 'querystring';
import React from 'react';
import ticketmasterIcon from '../images/tm.png';
import stubhubIcon from '../images/sh.png';
import vividseatsIcon from '../images/vs.png';
import killshotIcon from '../images/killshot.png';
import brokenLink from '../images/broken-link.png';
import spotify from '../images/spotify.png';
import nbsIcon from '../images/nbs.jpeg';
import eventDash from '../images/event-dashboard.svg';
import skyboxPNG from '../images/skybox.png';
import mrCleanPrimaryIcon from '../images/mr-clean/mr-clean-primary.svg';
import mrClearSecondaryIcon from '../images/mr-clean/mr-clean-secondary.svg';
import secondaryconslogo from '../images/secondary-consolidator/secondaryconslogo.svg';
import ticketEvolutionIcon from '../images/ticket-evo';

const nullObj = null;
const PRIMARY_TICKET = 'primary';
const STUBHUB_TYPE = 1;
const VIVIDSEATS_TYPE = 2;
const TICKET_EVOLUTION_TYPE = 14;
const { SECONDARY_CONSOLIDATOR_URL, MRCLEAN_URL } = process.env;
const ORGS_WITH_SECONDARY_CONSOLIDATOR_ACCESS = [32, 1];

const primaryLinks = new Set([3, 4, 6, 9, 10, 11, 12]);

const rangeFields = [
  'max_capacity',
  'primary_3_day',
  'primary_7_day',
  'primary_30_day',
  'primary_event_capacity',
  'primary_percent_av',
  'event_date',
  'checked',
  'days_until_checked_time',
  'onsale',
  'tm_primary_tickets_av',
  'tm_resale_tickets_av',
  'one_day_primary_pace',
  'three_day_primary_pace',
  'seven_day_primary_pace',
  'thirty_day_primary_pace',
  'sh_tickets_av',
  'sh_total_sales',
  'sh_3ma',
  'sh_7ma',
  'sh_sales_3ma',
  'sh_sales_7ma',
  'sh_1_day_min_price_ma',
  'sh_3_day_min_price_ma',
  'sh_7_day_min_price_ma',
  'sh_30_day_min_price_ma',
  'sh_num_viewing',
  'sh_min_price',
  'sb_total_num_purchased',
  'sb_total_num_held',
  'sb_total_num_sold',
  'sb_seven_day_num_sold',
  'sb_thirty_day_num_sold',
  'sb_last_invoice_date',
  'sb_pace',
  'sb_one_day_pace',
  'sb_three_day_pace',
  'sb_thirty_day_pace',
  'sb_total_margin',
  'sb_thirty_day_margin',
  'sb_seven_day_margin',
  'sb_today_margin',
  'sb_today_num_sold',
  'sh_sales_24hr',
  'primary_min_price_face',
  'primary_min_price_total',
  'days_since_last_sale',
  'days_since_last_purchase',
  'days_until_event',
  'total_cost_of_tickets_held',
  'tickets_needed_to_sell_per_hour',
  'tickets_needed_to_sell_per_day',
  'primary_tickets_cost',
  'cloakedness',
];

const zero = 0;

export const searchQueryString = (currentPage, formValues, sorting) => {
  const currFormValues = { ...formValues };
  /** @namespace querystring.stringify * */
  let queryStr = `?page=${currentPage}`;

  rangeFields.forEach(v => {
    if (
      (typeof currFormValues[`${v}_low`] !== 'undefined' &&
        currFormValues[`${v}_low`] !== '' &&
        currFormValues[`${v}_low`] !== null) ||
      (typeof currFormValues[`${v}_high`] !== 'undefined' &&
        currFormValues[`${v}_high`] !== '' &&
        currFormValues[`${v}_high`] !== null)
    ) {
      currFormValues[v] = [currFormValues[`${v}_low`], currFormValues[`${v}_high`]].join(':');
    } else {
      delete currFormValues[v];
    }
  });

  if (Object.keys(currFormValues).length !== zero) {
    queryStr += `&${querystring.stringify(currFormValues)}`;
  }
  if (sorting.length) {
    const colSorting = sorting[0];
    if (Object.keys(colSorting).length !== zero) {
      queryStr += `&sort_column=${colSorting.columnName}&sort_order=${colSorting.direction.toUpperCase()}`;
    }
  }
  return queryStr;
};

export const getPricingPageEventLinks = (eventURLs, eventId = false, skyboxSalesLink = null, repsLinks, userOrg) => {
  const eventLinkHTML = [];

  /** @namespace el.source_type * */

  // Check for primary link(s) (3 or 4)
  const primaryLinkData = eventURLs?.find(el =>
    el.source_type ? el.source_type === PRIMARY_TICKET : primaryLinks.has(el.type)
  );

  let ctr = 0;
  // Primary
  if (primaryLinkData) {
    eventLinkHTML.push([primaryLinkData.url, ticketmasterIcon, ctr++]);
  } else {
    eventLinkHTML.push([null, brokenLink, ctr++]);
  }

  if (repsLinks) {
    // eventDash
    eventLinkHTML.push([`${process.env.KONAMI_URL}/event/dashboard/${eventId}`, eventDash, ctr++]);
  }

  // Stubhub (type 1)
  const stubhubLinkData = eventURLs.find(el => el.type === STUBHUB_TYPE);

  if (stubhubLinkData) {
    eventLinkHTML.push([stubhubLinkData.url, stubhubIcon, ctr++]);
  } else {
    eventLinkHTML.push([null, brokenLink, ctr++]);
  }

  // Vividseats (type 2)
  const vividseatsLinkData = eventURLs.find(el => el.type === VIVIDSEATS_TYPE);

  if (vividseatsLinkData) {
    /** @namespace vividseatsLinkData.foreign_id * */
    eventLinkHTML.push([vividseatsLinkData.url, vividseatsIcon, ctr++]);
  } else {
    eventLinkHTML.push([null, brokenLink, ctr++]);
  }

  const ticketEvoLinkData = eventURLs.find(el => el.type === TICKET_EVOLUTION_TYPE);
  if (ticketEvoLinkData) {
    eventLinkHTML.push([ticketEvoLinkData.url, ticketEvolutionIcon, ctr++]);
  } else {
    eventLinkHTML.push([null, brokenLink, ctr++]);
  }

  if (skyboxSalesLink) {
    eventLinkHTML.push([skyboxSalesLink, skyboxPNG, ctr++]);
  }

  if (ORGS_WITH_SECONDARY_CONSOLIDATOR_ACCESS.includes(userOrg)) {
    // Secondary consolidator
    eventLinkHTML.push([`${SECONDARY_CONSOLIDATOR_URL}/listings?konami_id=${eventId}`, secondaryconslogo, ctr++]);
  }

  // Mr. Clean Primary
  eventLinkHTML.push([`${MRCLEAN_URL}/tools/primary/${eventId}`, mrCleanPrimaryIcon, ctr++]);

  // Mr. Clean Secondary
  eventLinkHTML.push([`${MRCLEAN_URL}/tools/secondary/${eventId}`, mrClearSecondaryIcon, ctr++]);

  return eventLinkHTML
    .map(t => {
      return (
        // TODO: use history object from React Router and call history.pushState(url)
        <a
          href={t[0]}
          target="_blank"
          rel="noopener noreferrer"
          key={t[2]}
          style={{ display: 'inline-block', marginRight: 5, width: 27 }}
        >
          <img style={{ height: '24px' }} src={t[1]} alt={t[2]} />
        </a>
      );
    })
    .reduce((accu, elem) => (accu === nullObj ? [elem] : [...accu, ' ', elem]), null);
};

export const getEventLinks = (eventURLs, eventId = false, skyboxSalesLink = null, repsLinks) => {
  const eventLinkHTML = [];

  /** @namespace el.source_type * */

  // Check for primary link(s) (3 or 4)
  const primaryLinkData = eventURLs?.find(el =>
    el.source_type ? el.source_type === PRIMARY_TICKET : primaryLinks.has(el.type)
  );

  let ctr = 0;
  // Primary
  if (primaryLinkData) {
    eventLinkHTML.push([primaryLinkData.url, ticketmasterIcon, ctr++]);
  } else {
    eventLinkHTML.push([null, brokenLink, ctr++]);
  }

  if (repsLinks) {
    // eventDash
    eventLinkHTML.push([`${process.env.KONAMI_URL}/event/dashboard/${eventId}`, eventDash, ctr++]);
  }

  // Stubhub (type 1)
  const stubhubLinkData = eventURLs.find(el => el.type === STUBHUB_TYPE);

  if (stubhubLinkData) {
    eventLinkHTML.push([stubhubLinkData.url, stubhubIcon, ctr++]);
  } else {
    eventLinkHTML.push([null, brokenLink, ctr++]);
  }

  // Vividseats (type 2)
  const vividseatsLinkData = eventURLs.find(el => el.type === VIVIDSEATS_TYPE);

  if (vividseatsLinkData) {
    /** @namespace vividseatsLinkData.foreign_id * */
    eventLinkHTML.push([vividseatsLinkData.url, vividseatsIcon, ctr++]);
  } else {
    eventLinkHTML.push([null, brokenLink, ctr++]);
  }

  if (skyboxSalesLink) {
    eventLinkHTML.push([skyboxSalesLink, skyboxPNG, ctr++]);
  }

  // Killshot
  eventLinkHTML.push([`/event/pricing/${eventId}`, killshotIcon, ctr++]);

  return eventLinkHTML
    .map(t => {
      return (
        // TODO: use history object from React Router and call history.pushState(url)
        <a
          href={t[0]}
          target="_blank"
          rel="noopener noreferrer"
          key={t[2]}
          style={{ display: 'inline-block', marginRight: 5, width: 27 }}
        >
          <img style={{ height: '24px' }} src={t[1]} alt={t[2]} />
        </a>
      );
    })
    .reduce((accu, elem) => (accu === nullObj ? [elem] : [...accu, ' ', elem]), null);
};

export const getPerformerLinks = eventURLs => {
  const eventLinkHTML = [];
  let ctr = 0;

  /** @namespace el.source_type * */

  // nbs (type 1)
  const nbsLinkData = eventURLs.find(el => el.type === '1');

  if (nbsLinkData) {
    eventLinkHTML.push([nbsLinkData.url, nbsIcon, ctr++]);
  } else {
    eventLinkHTML.push([`javascript${String.fromCharCode(58)}void(0);`, brokenLink, ctr++]);
  }

  // Vividseats (type 2)
  const spotifyLinkData = eventURLs.find(el => el.type === '2');

  if (spotifyLinkData) {
    /** @namespace vividseatsLinkData.foreign_id * */
    eventLinkHTML.push([`https://open.spotify.com/artist/${spotifyLinkData.foreign_id}`, spotify, ctr++]);
  } else {
    eventLinkHTML.push([`javascript${String.fromCharCode(58)}void(0);`, brokenLink, ctr++]);
  }

  return eventLinkHTML
    .map(t => (
      // TODO: use history object from React Router and call history.pushState(url)
      <a href={t[0]} target="_blank" rel="noopener noreferrer" key={t[2]} style={{ display: 'inline-block' }}>
        <img style={{ height: '24px' }} src={t[1]} alt={t[2]} />
      </a>
    ))
    .reduce((accu, elem) => (accu === nullObj ? [elem] : [...accu, ' ', elem]), null);
};

export const getOnSaleDate = (eventURLs, onSaleDate, onSaleDateString, eventId) => {
  /** @namespace el.source_type * */
  // Check for primary link(s) (3 or 4)
  const primaryLinkData = eventURLs.find(el => el.source_type === PRIMARY_TICKET);
  if (!primaryLinkData || !onSaleDate) {
    return (
      <div>
        <span>{onSaleDateString}</span>
        <br />
        <a
          href={`https://mrclean.reps2.com/tools/primary/${eventId}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block' }}
        >
          P
        </a>
      </div>
    );
  }
  return onSaleDateString;
};

/* fixColumnPresets
  Info Array
    0: handles hiddenColumnNames
    1: handles columnOrderChange
    2: handles columnWidthChane
    3: handles pinnedColumns */
export const fixColumnPresets = (columnPresets, columns, columnWidths) =>
  columnPresets
    .map(column => {
      const newCol = { ...column };
      newCol.value = column.value.map(value => (Array.isArray(value) ? value : [value]));
      if (newCol.value.length < 2) {
        newCol.value.push(columns, columnWidths, []);
      }
      return newCol;
    })
    .map(columnWidth => {
      if (columnWidth.value.length < 3) {
        columnWidth.value.push(columnWidths, []);
      } else {
        columnWidths
          .filter(col => {
            // This seems like it will only return true (pass filter) if NONE of the cols match.. which seems wrong?
            let flag = true;
            columnWidth.value[2].map(width => {
              if (width.columnName === col.columnName) {
                flag = false;
              }

              // Why return?
              return width;
            });

            // Can't we just return the condition above?
            return flag;
          })
          .map(col => columnWidth.value[2].push(col));
      }
      return columnWidth;
    });

export const fixColumnOrder = (savedOrder, order) => {
  if (typeof savedOrder === 'string') {
    order.unshift(savedOrder);
    return order;
  }

  for (let i = 0; i < order.length; i++) {
    if (savedOrder.indexOf(order[i]) === -1) {
      savedOrder.push(order[i]);
    }
  }
  return savedOrder;
};
